import { LayoutObjectStore } from '@yard/stores/LayoutObjectStore'
import { OccupancyStore } from '@yard/stores/OccupancyStore'
import { YardBlockStore } from '@yard/stores/YardBlockStore'
import { BerthStore } from '@yard/stores/berth.store'
import { PierStore } from '@yard/stores/pier.store'
import { RailTrackStore } from '@yard/stores/rail-track.store'
import { RoadNetworkStore } from '@yard/stores/road-network.store'
import { BerthViewStore } from './nodes/berth.view-store'
import { FlexibleBlockViewStore } from './nodes/flexible-block.view-store'
import { LayoutObjectViewStore } from './nodes/layout-object.view-store'
import { RailTrackViewStore } from './nodes/rail-track.view-store'
import { RoadNetworkViewStore } from './nodes/road-network.view-store'
import { YardBlockViewStore } from './nodes/yard-block.view-store'
export class YardSetupViewStore {
  yardBlockViewStore: YardBlockViewStore
  flexibleBlockViewStore: FlexibleBlockViewStore
  layoutObjectViewStore: LayoutObjectViewStore
  berthViewStore: BerthViewStore
  railTrackViewStore: RailTrackViewStore
  roadNetworkViewStore: RoadNetworkViewStore

  constructor(
    yardBlockStore: YardBlockStore,
    layoutObjectStore: LayoutObjectStore,
    berthStore: BerthStore,
    railTrackStore: RailTrackStore,
    pierStore: PierStore,
    occupancyStore: OccupancyStore,
    roadNetworkStore: RoadNetworkStore,
  ) {
    this.yardBlockViewStore = new YardBlockViewStore(
      yardBlockStore,
      occupancyStore,
      roadNetworkStore,
    )
    this.yardBlockViewStore = new YardBlockViewStore(
      yardBlockStore,
      occupancyStore,
      roadNetworkStore,
    )
    this.flexibleBlockViewStore = new FlexibleBlockViewStore(yardBlockStore)
    this.layoutObjectViewStore = new LayoutObjectViewStore(layoutObjectStore, roadNetworkStore)
    this.berthViewStore = new BerthViewStore(berthStore, pierStore)
    this.railTrackViewStore = new RailTrackViewStore(railTrackStore)
    this.roadNetworkViewStore = new RoadNetworkViewStore(roadNetworkStore)
  }
}
